import { render, staticRenderFns } from "./AscFaultMonitorItem.vue?vue&type=template&id=2af08b16&"
import script from "./AscFaultMonitorItem.vue?vue&type=script&lang=js&"
export * from "./AscFaultMonitorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports